import { render } from "./AdminInboxReviewPage.vue?vue&type=template&id=6e65fe32&scoped=true"
import script from "./AdminInboxReviewPage.vue?vue&type=script&lang=js"
export * from "./AdminInboxReviewPage.vue?vue&type=script&lang=js"

import "./AdminInboxReviewPage.vue?vue&type=style&index=0&id=6e65fe32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e65fe32"]])

export default __exports__